// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pm-summary-index[data-v-67d09fda] {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.pm-summary-index .filters[data-v-67d09fda] {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}", ""]);
// Exports
module.exports = exports;
